// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:06:15

export default {
  "id": "merge-master-1",
  "slug": "merge-master-1",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/3755ef4b7c044483a659fb93b77c210c-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/3755ef4b7c044483a659fb93b77c210c/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Merge Master",
      "description": "A casual mobile game centered around matching and elimination. The game features vibrant colors, coupled with a visual style rich in beach elements. With background music and sound effects reminiscent of leisurely walks along the beach, it creates a relaxed beach-strolling environment that immerses players in an auditory experience.",
      "instructions": "Players aim to combine larger numbers by clicking on adjacent identical numbers on the main game board to eliminate them and create a new number twice as large.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1player",
        "block",
        "colormatch",
        "relaxing"
      ]
    },
    "zh-CN": {
      "title": "合并大师",
      "description": "一款以匹配和消除为中心的休闲手机游戏。游戏采用鲜艳的色彩，并结合丰富的海滩元素视觉风格。背景音乐和音效让人联想到悠闲的海滩散步，营造出一种轻松的海滩漫步环境，让玩家沉浸在听觉体验中。",
      "instructions": "玩家旨在通过点击主游戏板上相邻的相同数字来组合更大的数字，消除它们并创建一个大小翻倍的新数字。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "1玩家",
        "阻挡",
        "颜色匹配",
        "放松"
      ]
    },
    "zh-TW": {
      "title": "合併大師",
      "description": "一款以配對和淘汰為核心的休闲手機遊戲。遊戲特色是鮮豔的顏色，結合充滿海灘元素的視覺風格。背景音樂和音效令人聯想起在海岸邊悠閒漫步的情境，打造了一個讓玩家沉浸於聽覺體驗的輕鬆海灘散步環境。",
      "instructions": "玩家目標通過點擊主遊戲板中相鄰的相同數字來合併較大的數字，消除它們並創造一個兩倍大的新數字。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "1人遊戲",
        "阻擋",
        "顏色匹配",
        "放鬆"
      ]
    },
    "zh-HK": {
      "title": "合併大師",
      "description": "一個以匹配及消除為核心的輕鬆手機遊戲。遊戲採用鮮豔的色彩，並結合充滿海灘元素的視覺風格。背景音樂及音效令人聯想起悠閒的海灘散步，創造出放鬆的海灘散步環境，讓玩家沉浸於聽覺體驗之中。",
      "instructions": "玩家目標透過在主遊戲板上點擊鄰近的相同數字，將其消除並創造出一個兩倍大的新數字。",
      "genres": [
        "輕鬆",
        "謎題"
      ],
      "tags": [
        "1玩家",
        "阻擋",
        "顏色匹配",
        "輕鬆"
      ]
    },
    "ja": {
      "title": "マージマスター",
      "description": "ビーチ要素に豊かなビジュアルスタイルを持ち、色鮮やかなカジュアルモバイルゲーム。背景音楽と効果音はビーチでのリラックスした散歩を思い起こさせるもので、プレイヤーを聴覚体験に没頭させるリラックスしたビーチ散策の環境を作り出します。",
      "instructions": "プレイヤーは、メインゲームボード上で同じ数字の隣接する数字をクリックして組み合わせ、それらを消去し、2倍の大きさの新しい数字を作成することを目指します。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "ブロック",
        "カラーメッチ",
        "リラックス"
      ]
    },
    "ko": {
      "title": "합성 마스터",
      "description": "해변 요소가 풍부한 시각적 스타일과 함께, 매칭 및 제거를 중심으로 한 캐주얼 모바일 게임. 배경 음악과 사운드 이펙트는 해변에서의 쉬운 산책을 연상시키며,玩家에게 풍부한 청각 경험을 제공하는 편안한 해변 산책 환경을 조성합니다.",
      "instructions": "플레이어들은 주요 게임 보드에서 인접한 같은 숫자를 클릭하여 제거하고 두 배 큰 새로운 숫자를 생성하는 것을 목표로 합니다.",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "블록",
        "컬러매치",
        "쉬운"
      ]
    },
    "fr": {
      "title": "Maître de Fusion",
      "description": "Un jeu mobile casual centré sur le matching et l'élimination. Le jeu se caractérise par des couleurs vives, associées à un style visuel riche en éléments de plage. Avec une musique de fond et des effets sonores rappelant des promenades relaxantes sur la plage, il crée un environnement de promenade en bord de mer qui plongeon les joueurs dans une expérience auditive.",
      "instructions": "Les joueurs visent à combiner des nombres plus grands en cliquant sur des nombres identiques adjacents sur le plateau principal du jeu pour les éliminer et créer un nouveau nombre deux fois plus grand.",
      "genres": [
        "Accordéon",
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "bloquer",
        "correspondance de couleur",
        "relaxant"
      ]
    }
  }
};
